
//const BASE_PATH = 'http://localhost:3000/api';

const Endpoints = {
//   LOGIN: `${BASE_PATH}/auth/login`,
//   VERIFYOTP: `${BASE_PATH}/auth/verifyOTP`,
//   DELETE_ACCOUNT: `${BASE_PATH}/auth/deleteUser`,
  //USER_BY_ID: (id: number | string) => `${BASE_PATH}users/${id}`,
  
  // Auth Endpoints
  LOGIN: `/auth/login`,
  VERIFY_OTP: `/auth/verifyOTP`,
  DELETE_ACCOUNT: `/auth/deleteUser`,

};

export default Endpoints;